import { useMemo } from 'react';
import { useGetDefaultCaptionSequenceQuery } from '../services/assetApi';

const NO_SUGGESTIONS: readonly string[] = [];

/**
 * Ghost-autocomplete candidates for the caption editor: the Default Caption
 * Sequence's display names, in its sort order (DV-2859, folding in the
 * DV-2723 BE recommendation). One RTK Query cache entry serves every card on
 * the grid — the hook is called per CaptionEditor, and RTK dedupes the
 * subscriptions onto a single fetch.
 *
 * While the fetch is pending, or if it fails, there are simply no
 * suggestions. Deliberately NO hardcoded fallback: the old list is what put
 * off-sequence names in front of editors in the first place, and a ghost
 * that Caption Sort cannot place is worse than no ghost.
 */
export function useCaptionSuggestions(): readonly string[] {
  const { data } = useGetDefaultCaptionSequenceQuery();
  return useMemo(
    () => data?.captions.map((item) => item.caption) ?? NO_SUGGESTIONS,
    [data]
  );
}
